var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "qianbao") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "Market-\\u6536\\u7F29",
    transform: "translate(-943.000000, -108.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12\\u5907\\u4EFD",
    transform: "translate(923.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9088316,28.15 L34.9088316,31.9147562 L35.85,31.9147562 L35.85,37.2617388 L34.9088316,37.2617388 L34.9088316,41.0265225 L20.15,41.0265225 L20.15,28.15 L34.9088316,28.15 Z M33.3264949,29.7323367 L21.7323367,29.7323367 L21.7323367,39.4441858 L33.3264949,39.4441858 L33.3264949,37.2617388 L32.2353266,37.2617388 L32.0310022,37.2546568 C31.3577427,37.2076889 30.7652371,36.9295637 30.3295776,36.4939212 C29.8503637,36.014726 29.5617388,35.3457575 29.5617388,34.5882612 C29.5617388,33.8307625 29.8503655,33.1617856 30.3295819,32.6825833 C30.8088069,32.2033723 31.4778143,31.9147562 32.2353266,31.9147562 L32.2353266,31.9147562 L33.3264949,31.9147562 L33.3264949,29.7323367 Z M34.2676633,33.4970929 L32.2353266,33.4970929 L32.0985659,33.5038763 C31.8322542,33.5308083 31.6100344,33.6367218 31.4469212,33.7998397 C31.2566259,33.9901407 31.1441858,34.2608937 31.1441858,34.5882612 C31.1441858,34.9156167 31.2566274,35.186373 31.4469273,35.3766785 C31.6372259,35.5669826 31.9079733,35.6794296 32.2353266,35.6794296 L32.2353266,35.6794296 L34.2676633,35.6794296 L34.2676633,33.4970929 Z",
    id: "qianbao"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4511b78e4a15aaa3d374415ad17a56de.svg";
export { ForwardRef as ReactComponent };